import { Component, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { TableComponent } from '../table/table.component';
import { HelpModuleVm } from '../generated/HelpFiles/Models/HelpModuleVm';
import { SystemMessageService } from '../../core/system-message/system-message-service';

@Component({
    selector: 'pcg-new-help-module-button',
    templateUrl: './new-help-module-button.component.html',
    styleUrls: ['./new-help-module-button.component.scss'],
    standalone: false
})
export class NewHelpModuleButtonComponent {

    @Input() table!: TableComponent<HelpModuleVm>;;

    newModuleName!: string;
    isError = false;
    errorMessage = "";

    constructor(
        private httpClient: HttpClient
        , private ms: SystemMessageService
    ) { }

    addNewModuleName(newModuleName: string) {
        if (
            newModuleName == null 
            || newModuleName === "" 
            || newModuleName.trim().length === 0
        ) {
            this.newModuleName = "";
            this.isError = true;
            this.errorMessage = "Module Name required.";
            return;
        }
        
        this.httpClient.get(`api/HelpFiles/HelpFiles/SaveModuleName/?moduleName=${newModuleName}`)
            .subscribe((message: any) => {
                if (message.isSuccessful) { this.ms.setSystemMessage("Module has been saved."); }	
                this.newModuleName = "";
                this.table.ajaxReload();	
                this.isError = false;
                this.errorMessage = "";
            }
        );      
    }

    resetValidation() {
        this.isError = false;
        this.errorMessage = "";
    }
}
